import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpRequestOptions} from '@dcp/configurator';
import {Observable, throwError} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {DcpKymaService} from './dcp-kyma.service';
import {ProductGeneral} from '@app/model/dcp-product-general';
import {
  GRAPHQL_QUERY_PRODUCT_BASIC,
  GRAPHQL_QUERY_PRODUCT_FULL,
  GRAPHQL_QUERY_PRODUCT_SLMID,
} from './graphql/showCosmosDbProductsV3';

@Injectable({
  providedIn: 'root',
})
export class GraphqlEdgeService {
  constructor(private http: HttpClient, private kymaService: DcpKymaService) {}

  getProductByTechnicalName(technicalName: string, queryType: string = 'SLMID'): Observable<ProductGeneral> {
    const queryMap = {
      BASIC: GRAPHQL_QUERY_PRODUCT_BASIC,
      FULL: GRAPHQL_QUERY_PRODUCT_FULL,
      SLMID: GRAPHQL_QUERY_PRODUCT_SLMID,
    };
    const query = queryMap[queryType] || GRAPHQL_QUERY_PRODUCT_SLMID;

    const variables = {
      filter: `{'products.technicalName': '${technicalName}'}`,
      skip: 0,
      top: 1,
    };
    const body = {query: query, variables: variables};
    return this.kymaService
      .prepareAuthConfig()
      .pipe(
        concatMap((config: HttpRequestOptions) =>
          this.http.post<ProductGeneral>(`${this.kymaService.getUrl('graphqlEdge')}`, body, config)
        )
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
